import { ElasticSearchFile } from "dsilo-ui-components";
import React from "react";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { PUBLIC_PATH } from "../../constants";
import { onSearch } from '../../store/actions';
import { Loader } from "../loader";

const ElasticSearchFileComponent = props => {

    return (
        <ElasticSearchFile
            {...props} PUBLIC_PATH={PUBLIC_PATH} loader={<Loader />} />
    );
};

const mapDispatchToProps = {
  
    onSearch,
};

const mapStateToProps = state => {
    return {
        appConfig: state.appConfig.app,
        apps: state.app.app,
        login: state.login,
        user: state.user,
        formData: state.form,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ElasticSearchFileComponent));
